import React from 'react';
import styled from 'styled-components';
import { GEL_SPACING, GEL_SPACING_QUIN } from '@bbc/gel-foundations/spacings';
import { GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_GROUP_2_SCREEN_WIDTH_MAX } from '@bbc/gel-foundations/breakpoints';
import { C_WHITE } from '@bbc/psammead-styles/colours';
import { getPica } from '@bbc/gel-foundations/typography';
import { getSansRegular } from '@bbc/psammead-styles/font-styles';
import { string, shape, node, func } from 'prop-types';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
var StyledLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "StyledLink",
  componentId: "dda4ku-0"
})(["", " ", " display:inline-block;color:", ";text-decoration:none;height:2.25rem;border:0.0625rem solid ", ";margin:", " 0 ", " ", ";@media (min-width:", "){line-height:calc(2.25rem - ", ");}@media (max-width:", "){height:", ";}"], function (_ref) {
  var script = _ref.script;
  return script && getPica(script);
}, function (_ref2) {
  var service = _ref2.service;
  return service && getSansRegular(service);
}, C_WHITE, C_WHITE, GEL_SPACING, GEL_SPACING, GEL_SPACING, GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_SPACING, GEL_GROUP_2_SCREEN_WIDTH_MAX, GEL_SPACING_QUIN);
var StyledSpan = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledSpan",
  componentId: "dda4ku-1"
})(["margin:0.1875rem;display:inline-block;height:calc(100%);padding:0 ", ";", ":hover &,", ":focus &{margin:0;border:0.1875rem solid ", ";}@media (max-width:", "){line-height:calc(", " - ", ");}"], GEL_SPACING, StyledLink, StyledLink, C_WHITE, GEL_GROUP_2_SCREEN_WIDTH_MAX, GEL_SPACING_QUIN, GEL_SPACING);

var ScriptLink = function ScriptLink(_ref3) {
  var children = _ref3.children,
      script = _ref3.script,
      service = _ref3.service,
      href = _ref3.href,
      variant = _ref3.variant,
      onClick = _ref3.onClick;
  return /*#__PURE__*/React.createElement(StyledLink, {
    script: script,
    service: service,
    href: href,
    "data-variant": variant,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(StyledSpan, null, children));
};

var noopFunction = function noopFunction() {};

ScriptLink.defaultProps = {
  variant: null,
  onClick: noopFunction
};
ScriptLink.propTypes = {
  children: node.isRequired,
  script: shape(scriptPropType).isRequired,
  service: string.isRequired,
  href: string.isRequired,
  variant: string,
  onClick: func
};
export default ScriptLink;